var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"classes":['tw-shadow-md', 'tw-bg-white', 'tw-rounded-lg'],"max-width":520,"name":"app-modal","width":"95%","height":"auto","adaptive":"","scrollable":""}},[_c('portal-target',{attrs:{"name":"app-modal-content","slim":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }